const Insurance = () => import('@/pages/insurance/Insurance');

export default {
  component: Insurance,
  path: '/insurance/:type(travel|car|motor|pet|accident)/:carno?', //20210530 Wen modify 括號內不可有空白,首頁Banners快速試算連結會失效 (travel|car|motor|accident|pet|vaccine)  //20220414 Wen Modify vaccine 下架  
  name: 'insurance',
  props: route => ({
    ...route.params
  }),
  // beforeEnter(to, from, next) {
  //   const { type } = to.params;
  //   const isExist = /\b(travel|car|motor)\b/.test(type);
  //   if (isExist) return next();
  //   return next('/');
  // }

};